import React, { Dispatch, SetStateAction, useState } from "react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import { Box, Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { Trans } from "react-i18next";
import { invoiceFeeBankAccount, invoicePaymentForGoodsBankAccount } from "@/features/my-order/features/order-history/constants";
import CustomIcon from "../../../../public/icons-v1_1";

function BankAccountInfoTooltipContent() {
  const [isPaymentAccountCopied, setIsPaymentAccountCopied] = useState(false);
  const [isFeeAccountCopied, setIsFeeAccountCopied] = useState(false);
  const { tTitle } = useI18nHelper();

  const handleCopy = async (
    text: string,
    setCopied: Dispatch<SetStateAction<boolean>>
  ) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  return (
    <Grid
      templateColumns={
        "minmax(112px, max-content) minmax(146px, max-content) 1fr"
      }
      gap={"6px"}
      whiteSpace={"nowrap"}
      alignItems={"center"}
    >
      <GridItem gridColumn={"1 / -1"}>
        <Text textStyle={"body-sm-medium"} color={"#444444"}>
          <Trans
            i18nKey={"order_history:invoice.bank_account_info_description"}
            components={{
              br: <br />,
            }}
          />{" "}
        </Text>
      </GridItem>

      <GridItem>
        <Text textStyle={"body-sm-bold"} color={"#444444"}>
          {tTitle("order_history:invoice.payment_for_goods")}/
          {tTitle("order_history:invoice.request_for_funds")}
        </Text>
      </GridItem>
      <GridItem>
        <Text textStyle={"body-sm-medium"} color={"#444444"}>
          {`${tTitle(
            "order_history:invoice.woori_bank"
          )} ${invoicePaymentForGoodsBankAccount}`}
        </Text>
      </GridItem>
      <GridItem>
        <Flex
          gap={"2px"}
          alignItems={"center"}
          cursor={"pointer"}
          className={"group"}
          onClick={() =>
            handleCopy(
              invoicePaymentForGoodsBankAccount,
              setIsPaymentAccountCopied
            )
          }
        >
          <Box
            _groupHover={{
              color: "#1272EF",
            }}
            color={"#8F8F8C"}
          >
            <CustomIcon
              src={isPaymentAccountCopied ? "check" : "copy"}
              width={12}
              height={12}
            />
          </Box>
          <Text
            textStyle={"caption-bold"}
            color={"#444444"}
            _groupHover={{
              color: isPaymentAccountCopied ? "#444444" : "#1272EF",
            }}
          >
            {isPaymentAccountCopied
              ? tTitle("order_history:invoice.copied")
              : tTitle("order_history:invoice.copy")}
          </Text>
        </Flex>
      </GridItem>

      <GridItem>
        <Text textStyle={"body-sm-bold"} color={"#444444"}>
          {tTitle("order_history:invoice.fee")}
        </Text>
      </GridItem>
      <GridItem>
        <Text textStyle={"body-sm-medium"} color={"#444444"}>
          {`${tTitle(
            "order_history:invoice.woori_bank"
          )} ${invoiceFeeBankAccount}`}
        </Text>
      </GridItem>
      <GridItem>
        <Flex
          gap={"2px"}
          alignItems={"center"}
          cursor={"pointer"}
          className={"group"}
          onClick={() =>
            handleCopy(invoiceFeeBankAccount, setIsFeeAccountCopied)
          }
        >
          <Box
            _groupHover={{
              color: "#1272EF",
            }}
            color={"#8F8F8C"}
          >
            <CustomIcon
              src={isFeeAccountCopied ? "check" : "copy"}
              width={12}
              height={12}
            />
          </Box>
          <Text
            textStyle={"caption-bold"}
            color={"#444444"}
            _groupHover={{
              color: isFeeAccountCopied ? "#444444" : "#1272EF",
            }}
          >
            {isFeeAccountCopied
              ? tTitle("order_history:invoice.copied")
              : tTitle("order_history:invoice.copy")}
          </Text>
        </Flex>
      </GridItem>

      <GridItem>
        <Text textStyle={"body-sm-bold"} color={"#444444"}>
          {tTitle("order_history:invoice.account_holder")}
        </Text>
      </GridItem>
      <GridItem>
        <Text textStyle={"body-sm-medium"} color={"#444444"}>
          {tTitle("order_history:invoice.unotrading_inc")}
        </Text>
      </GridItem>
    </Grid>
  );
}

export default BankAccountInfoTooltipContent;